module.exports = __webpack_public_path__ + "static/media/yuta-7.jpeg";